import dayjs from "dayjs"
import React, { useMemo } from "react"

import {
  DateFilterDto,
  DateFilterOperator,
  DateFilterType,
} from "@tfg/types/types/date-filter.dto"

import { type DateRangeValue } from "../DatePickerFilter"

import { useComponentOperatorMapping } from "./useComponentOperatorMapping"

export type DateFilterValueComponentFactory = {
  getComponentForOperator: (operator: DateFilterOperator) => React.ReactNode
  setDateRange: React.Dispatch<React.SetStateAction<DateRangeValue>>
}

export type DatePickerComponentProps = {
  dateFilter: DateFilterDto | null
  locale?: string
  onChange: (range: DateRangeValue) => void
}

export const useDatePickerComponent = ({
  dateFilter,
  locale = "fr",
  onChange,
}: DatePickerComponentProps): React.ReactNode => {
  const range: DateRangeValue = [
    dateFilter?.range?.startDate ?? dayjs().subtract(1, "day").toDate(),
    dateFilter?.range?.endDate ?? dayjs().toDate(),
  ]

  const componentOperatorMapping = useComponentOperatorMapping({
    locale,
    dateRange: range,
    onChange,
  })

  return useMemo((): React.ReactNode => {
    if (!dateFilter?.operator || dateFilter.type === DateFilterType.SLIDER) {
      return null
    }

    const mapping = componentOperatorMapping.find((mapping) =>
      mapping.operators.includes(dateFilter.operator)
    )

    if (!mapping) {
      return null
    }

    return mapping.component
  }, [componentOperatorMapping, dateFilter])
}
